import totalBg from "../../assets/images/total-bg.png";
import { formatPrice } from "../../helpers";

interface Props {
  className?: string;
  currency: string;
  total: number;
  label?: string;
}

const TotalPrice = ({
  className = "",
  currency,
  total,
  label = "Total Price",
}: Props) => {
  return (
    <div
      className={`relative rounded-md overflow-hidden min-h-[60px] py-3 pt-4 ${className}`}
    >
      <img
        src={totalBg}
        alt="total"
        className="absolute top-0 left-0 w-full h-full object-cover z-[-1]"
      />
      <p className="text-white text-center text-[16px] leading-[1]">{label}</p>
      <p className="text-center text-[#47FF94] text-[21px]">
        {formatPrice({ price: total, currency, locale: "en-US" })}
      </p>
    </div>
  );
};

export default TotalPrice;
